import { render, staticRenderFns } from "./AuthenMom.vue?vue&type=template&id=321aef68&scoped=true&"
import script from "./AuthenMom.vue?vue&type=script&lang=js&"
export * from "./AuthenMom.vue?vue&type=script&lang=js&"
import style0 from "./AuthenMom.vue?vue&type=style&index=0&id=321aef68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321aef68",
  null
  
)

export default component.exports